import { render } from "./CoffeeIcon.vue?vue&type=template&id=03427a6b&scoped=true"
const script = {}

import "./CoffeeIcon.vue?vue&type=style&index=0&id=03427a6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03427a6b"]])

export default __exports__